/* One editorial header for every theme-rendered storefront page. */
(() => {
  if (customElements.get('bb-site-header')) return;
  class BBSiteHeader extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._frame = 0;
      this._header = this.querySelector('.bb-header');
      this._dialogs = [...this.querySelectorAll('dialog')];
      const on = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal: this._abort.signal });
      on(this, 'click', event => this._click(event));
      on(window, 'scroll', () => this._queueUpdate(), { passive: true });
      on(window, 'resize', () => this._queueUpdate(), { passive: true });
      on(document, 'shopify:section:load', () => this._queueUpdate());
      on(document, 'shopify:section:unload', () => this._queueUpdate());
      on(document, 'shopify:section:reorder', () => this._queueUpdate());
      for (const dialog of this._dialogs) {
        on(dialog, 'close', () => this._closed(dialog));
        on(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      }
      this.querySelectorAll('[data-bb-js]').forEach(element => { element.hidden = false; });
      this._update();
    }
    disconnectedCallback() {
      this._dialogs?.forEach(dialog => { if (dialog.open) dialog.close(); });
      this._abort?.abort();
      this._abort = null;
      if (this._frame) cancelAnimationFrame(this._frame);
      if (!document.querySelector('bb-site-header dialog[open]')) document.body.classList.remove('bb-dialog-open');
    }
    _queueUpdate() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => { this._frame = 0; this._update(); });
    }
    _update() {
      if (!this._header) return;
      const surfaces = [...document.querySelectorAll('[data-bb-header-ink]')].map(element => ({
        rect: element.getBoundingClientRect(), ink: element.dataset.bbHeaderInk
      }));
      for (const group of this._header.children) {
        const control = group.classList.contains('bb-header-side')
          ? [...group.children].find(element => element.getClientRects().length > 0)
          : group;
        const rect = (control || group).getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;
        let ink = 'dark';
        for (const surface of surfaces) {
          if (surface.rect.left <= x && surface.rect.right >= x && surface.rect.top <= y && surface.rect.bottom >= y) ink = surface.ink;
        }
        group.classList.toggle('is-dark', ink === 'dark');
      }
    }
    _click(event) {
      const trigger = event.target.closest('[data-bb-dialog]');
      if (trigger && this.contains(trigger)) {
        const dialog = this.querySelector(`#${CSS.escape(trigger.dataset.bbDialog)}`);
        if (!dialog?.showModal) return;
        this._dialogs.forEach(item => { if (item !== dialog && item.open) item.close(); });
        dialog._returnFocus = trigger;
        dialog.showModal();
        document.body.classList.add('bb-dialog-open');
        trigger.setAttribute('aria-expanded', 'true');
        return;
      }
      const close = event.target.closest('[data-bb-close]');
      if (close) { close.closest('dialog')?.close(); return; }
      const link = event.target.closest('dialog a');
      if (link) link.closest('dialog').close();
    }
    _closed(dialog) {
      const trigger = dialog._returnFocus;
      trigger?.setAttribute('aria-expanded', 'false');
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      if (!this._dialogs.some(item => item.open)) document.body.classList.remove('bb-dialog-open');
    }
  }
  customElements.define('bb-site-header', BBSiteHeader);
})();
